// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2y0Ly","file":"styles_file__wKE0Y"};